import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=6a5a0e13&scoped=true"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"
import style0 from "./Links.vue?vue&type=style&index=0&id=6a5a0e13&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a0e13",
  null
  
)

export default component.exports